import type { ComponentProps, ReactElement } from 'react';
import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';
import { Slot } from 'radix-ui';

import { cn } from '../utils/tw-merge.util';

export const stackVariants = cva('flex flex-col', {
  variants: {
    gap: {
      xs: 'gap-1',
      sm: 'gap-1.5',
      md: 'gap-2',
      lg: 'gap-2.5',
      xl: 'gap-3',
      '2xl': 'gap-4',
    },
    align: {
      center: 'items-center',
      end: 'items-end',
    },
  },
  defaultVariants: {
    gap: 'md',
  },
});

type StackProps = ComponentProps<'div'> & VariantProps<typeof stackVariants> & { asChild?: boolean };

export function Stack({ gap, align, asChild = false, className, ...props }: StackProps): ReactElement {
  const Comp = asChild ? Slot.Root : 'div';

  return <Comp data-slot="stack" className={cn(stackVariants({ gap, align }), className)} {...props} />;
}
